module.exports = __webpack_public_path__ + "static/media/Appliances.0c0a9dca.png";